import React from 'react';
import cx from 'classnames';
import {useTranslation} from 'react-i18next';

import {IconTypes, Bar, Button} from '@pexip/components';

import {TestId} from '../../../../test/testIds';
import {IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY} from '../../..';
import {FoldedSelfviewButton} from '../FoldedSelfview/FoldedSelfviewButton.view';
import {stopMouseEventPropagation} from '../../../utils/domEventsHandles';

import styles from './InMeetingSelfview.module.scss';

export const InMeetingSelfviewHeader: React.FC<{
    isMobileDevice?: boolean;
    isMaximized?: boolean;
    onClick: () => void;
    setIsMaximized?: React.Dispatch<React.SetStateAction<boolean>>;
    controlsVisible: boolean;
    areEffectsEnabled: boolean;
    areEffectsApplied: boolean;
    openEffects: () => void;
}> = ({
    isMobileDevice,
    isMaximized,
    controlsVisible,
    onClick,
    setIsMaximized,
    areEffectsApplied,
    areEffectsEnabled,
    openEffects,
}) => {
    const {t} = useTranslation();

    return (
        <Bar
            className={styles.header}
            position="absoluteTop"
            flexDirection={isMaximized ? 'row' : 'rowReverse'}
        >
            {isMaximized ? (
                <Button
                    colorScheme="light"
                    variant="secondary"
                    onClick={() => setIsMaximized?.(false)}
                    onPointerDownCapture={stopMouseEventPropagation()}
                >
                    {t('common.close', 'Close')}
                </Button>
            ) : (
                (!isMobileDevice || controlsVisible) && (
                    <div className={styles.headerControls}>
                        <FoldedSelfviewButton
                            onClick={onClick}
                            onPointerDownCapture={stopMouseEventPropagation()}
                            onTouchStartCapture={(e: React.TouchEvent) =>
                                e.stopPropagation()
                            }
                            data-testid={TestId.ButtonCollapseSelfview}
                            tooltipText={t(
                                'meeting.hide-self-view',
                                'Hide self-view',
                            )}
                            aria-label={t(
                                'meeting.hide-self-view',
                                'Hide self-view',
                            )}
                            className={cx(
                                styles.collapseSelfviewButton,
                                isMobileDevice && styles.mobile,
                            )}
                            backgroundTransparency={
                                IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY
                            }
                            icon={IconTypes.IconPasswordHide}
                            isMobileDevice={isMobileDevice}
                            variant="neutral"
                            colorScheme="dark"
                            noHover={isMobileDevice}
                            style={{color: '#fff'}}
                            size="medium"
                            iconSize={isMobileDevice ? 'medium' : 'small'}
                        />
                        {areEffectsEnabled && (
                            <FoldedSelfviewButton
                                aria-label={t(
                                    'media.background-effects-action',
                                    'Change background effect',
                                )}
                                tooltipText={t(
                                    'media.background-effects-action',
                                    'Change background effect',
                                )}
                                tooltipPosition="bottomEnd"
                                onClick={openEffects}
                                isActive={areEffectsApplied}
                                icon={IconTypes.IconBackgroundReplace}
                                onPointerDownCapture={stopMouseEventPropagation(
                                    true,
                                )}
                                onTouchStartCapture={(e: React.TouchEvent) =>
                                    e.stopPropagation()
                                }
                                isMobileDevice={isMobileDevice}
                                className={cx(
                                    styles.effectsButton,
                                    isMobileDevice && styles.mobile,
                                )}
                                backgroundTransparency={
                                    IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY
                                }
                                data-testid={
                                    areEffectsApplied
                                        ? TestId.ButtonMeetingBackgroundEffectsOn
                                        : TestId.ButtonMeetingBackgroundEffectsOff
                                }
                                size="medium"
                                variant="neutral"
                                noHover={isMobileDevice}
                                iconSize={isMobileDevice ? 'medium' : 'small'}
                            />
                        )}
                    </div>
                )
            )}
        </Bar>
    );
};
